import './App.css'
import { Routes, Route, useNavigate } from 'react-router-dom';
import TaskPage from './TaskPage';
import { useState, type JSX } from 'react';
import { formulas } from './data/formulas';
import { generatePDF } from './utils/GeneratePDF';
import InfoPage from './InfoPage';

export default function App(): JSX.Element {
  const [announcement, setAnnouncement] = useState('');

  const navigate = useNavigate();
  const categories = [...new Set(formulas.map(f => f.category))];
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const toggleCategory = (category:string) => {
    setSelectedCategories(prev => {
      const updated = prev.includes(category)
        ? prev.filter(c => c !== category)
        : [...prev, category];
        if (updated.length === 1){
          setAnnouncement(`Odabrana jedna kategorija`);
        }
        else if (updated.length === 2){
          setAnnouncement(`Odabrane dvije kategorije`);
        }
        else{ 
          setAnnouncement(`Odabrano ${updated.length} kategorija`);
        }
      return updated;
      }
    );
  };

  const isDisabled = selectedCategories.length === 0;
  const allSelected = selectedCategories.length === categories.length;
  const toggleAllCategories = () => {
    if (allSelected) {
      setSelectedCategories([]);
      setAnnouncement('Sve kategorije su poništene');
    } else {
      setSelectedCategories(categories);
      setAnnouncement('Sve kategorije su odabrane');
    }
  };

  return (
    <div className="App" role="main">
      <div aria-live="polite" className="sr-only">
        {announcement}
      </div>
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <button onClick={() =>
                navigate('/upute')
              } aria-label="Otvori upute za korištenje aplikacije">
                Otvori upute za korištenje aplikacije
              </button>
              <section className='category-menu'>
                <h1 id="categories-legend" className='pocetna-naslov' tabIndex={0}>
                  Odaberi kategorije zadataka
                </h1>
                <p id="category-help" className="category-help" tabIndex={0}>
                  Koristi tipku Tab za kretanje i razmaknicu za odabir kategorije
                </p>
                
                <div className='checkbox-group'
                  aria-describedby='category-help'>
                  <div className="checkbox-item">
                    <input
                      id="select-all"
                      type="checkbox"
                      checked={allSelected}
                      onChange={toggleAllCategories}
                      aria-checked={allSelected}
                    />
                    <label htmlFor="select-all">
                      Odaberi sve kategorije
                    </label>
                  </div>
                  {categories.map(category => {
                    const id = `cat-${category}`;
                    return (
                      <div key={category} className="checkbox-item">
                        <input type='checkbox' id={id}
                        checked={selectedCategories.includes(category)}
                        onChange={() => toggleCategory(category)} />
                        <label htmlFor={id}>{category}</label>
                      </div>
                    );})}
                  </div>
                </section>
                <button onClick={() => generatePDF(formulas)} aria-label="Preuzmi dokument sa svim formulama u PDF formatu" >
                  Preuzmi dokument s formulama u PDF formatu
                </button>
                <div className="navigate-button">
                  <button
                    disabled = {isDisabled}
                    onClick={() =>
                      navigate('/zadaci/prva-razina', {
                        state: { selectedCategories, taskType: 'A' }
                      })
                    }
                    aria-label='Započni rješavanje prve razine zadataka s odabranim kategorijama'
                  >
                    Započni prvu razinu zadataka
                  </button>
                </div>
                <div className="navigate-button">
                  <button
                    disabled = {isDisabled}
                    onClick={() =>
                      navigate('/zadaci/druga-razina', {
                        state: { selectedCategories, taskType: 'B' }
                      })
                    }
                    aria-label='Započni rješavanje druge razine zadataka s odabranim kategorijama'
                  >
                    Započni drugu razinu zadataka
                  </button>
                  {isDisabled && (
                    <p tabIndex={0}>
                      Odaberite barem jednu kategoriju zadataka
                    </p>
                  )}
              </div>
            </div>
          }
        />
        <Route
          path="/zadaci/prva-razina"
          element={<TaskPage/>}
        />
        <Route 
          path="/zadaci/druga-razina"
          element={<TaskPage/>}
        />
        <Route 
          path="/upute"
          element={<InfoPage/>}
        />
      </Routes>
    </div>
  );
}